export const HARVEST_NOTES_MAX_LENGTH = 250;
export const MAX_HARVEST_RECORD_AMOUNT_GRAMS = 99_999_999.99;
export const MIN_HARVEST_RECORD_AMOUNT_GRAMS = 0.01;
